<template>
  <div>
<!--    상단-->
    <div class="flex justify-between">
      <div ref="printPhotoUploadGridModulHead">
        <div v-if="customTitle && isShowTitle" style="page-break-before: always">
          <slot name="customTitle"></slot>
        </div>
        <div v-else-if="!customTitle && isShowTitle && !!sectionTitle" class="mt-6 mb-4">
          <h5><i class="dot"></i>{{ sectionTitle }}</h5>
        </div>
      </div>
      <div v-if="isCheckMode && !readonly && !isPrint" class="ml-auto header-buttons">
        <vs-button class="desktop-only" color="secondary" @click="handleAdd">사진추가</vs-button>
        <vs-button class="ml-4" color="secondary" type="border" @click="handleRemove">선택삭제</vs-button>
      </div>
    </div>

    <!-- 빈 목록 안내 메시지 -->
    <div v-if="dataList.length === 0 && !isPrint" class="empty-list-message">
      <div class="empty-content">
        <i class="feather icon-camera empty-icon"></i>
        <p class="empty-text">사진을 추가해주세요</p>
        <vs-button
          color="primary"
          type="filled"
          @click="handleAdd"
          class="empty-add-btn"
        >
          <i class="feather icon-plus mr-2"></i>
          첫 번째 사진 추가
        </vs-button>
      </div>
    </div>

    <!-- Desktop 테이블 레이아웃 -->
    <div class="desktop-layout" v-if="dataList.length > 0 || isPrint">
      <table>
        <colgroup>
          <col v-if="isCheckMode && !readonly && !isPrint" width="50" />
          <col width="50" />
          <col />
          <col />
        </colgroup>
        <thead>
          <tr>
            <th v-if="isCheckMode && !readonly && !isPrint">
              <vs-checkbox
                :value="checkData.length === dataList.length && 0 < dataList.length"
                class="justify-center mx-0" @click.native="onClickAllCheckbox" />
            </th>
            <th>No.</th>
            <th>조치 전 사진</th>
            <th>조치 후 사진</th>
          </tr>
        </thead>
        <tbody>
        <tr v-for="(item, item_i) in dataList" :key="`filelist_${item.id}_${item_i}`">
          <th v-if="isCheckMode && !readonly && !isPrint">
            <vs-checkbox v-model="checkData" :vs-value="item.id" class="justify-center mx-0" />
          </th>
          <th>{{ item_i + 1}}</th>
          <td>
            <div v-if="isPrint">
              <div  style="height: 9.5cm; flex: 1" class="flex items-center justify-center overflow-hidden">
                <img :src="item.이전사진.path" width="100%" height="100%" class="max-w-full w-auto object-contain"/>
              </div>
              <p class="print-input mt-2">{{ item.이전사진.input }}</p>
            </div>
            <div v-else>
              <!-- ========== Image ========== -->
              <div class="upload-content__file">
                <div class="upload-content__content">
                  <img v-if="isPrint" class="w-full h-full printImg" :src="item.이전사진.thumb" alt="" />
                  <FileUploaderTransparent
                    v-else
                    style="background-size: contain; background-repeat: no-repeat"
                    v-model="item.이전사진.image"
                    :readonly="readonly"
                    @input="setFile(item_i, '이전사진', item.이전사진.image)"
                    @progress="(state) => { fileProgress(item_i, '이전사진',  state) }"
                  />
                </div>
                <simple-spinner
                  v-if="item.이전사진.showSpinner"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #cdcdcdaa"
                />
              </div>
              <!-- ========== Footer ========== -->
              <div v-if="isCustomFooter">
                <slot name="customFooter" :index="item_i" :type="'이전사진'"></slot>
              </div>
              <div v-else class="mt-2">
                <p v-if="isPrint">{{ item.이전사진.input }}</p>
                <ml-input v-else v-model="item.이전사진.input" :placeholder="item.이전사진.placeholder" class="w-full flex-1"/>
              </div>
            </div>
          </td>
          <td>
            <div v-if="isPrint">
              <div  style="height: 9.5cm; flex: 1" class="flex items-center justify-center overflow-hidden">
                <img :src="item.이후사진.path" width="100%" height="100%" class="max-w-full w-auto object-contain"/>
              </div>
              <p class="print-input mt-2">{{ item.이후사진.input }}</p>
            </div>
            <div v-else>
              <!-- ========== Image ========== -->
              <div class="upload-content__file">
                <div class="upload-content__content">
                  <img v-if="isPrint" class="w-full h-full printImg" :src="item.이후사진.thumb" alt="" />
                  <FileUploaderTransparent
                    v-else
                    style="background-size: contain; background-repeat: no-repeat"
                    v-model="item.이후사진.image"
                    :readonly="readonly"
                    @input="setFile(item_i, '이후사진', item.이후사진.image)"
                    @progress="(state) => { fileProgress(item_i, '이후사진', state) }"
                  />
                </div>
                <simple-spinner
                  v-if="item.이후사진.showSpinner"
                  style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #cdcdcdaa"
                />
              </div>
              <!-- ========== Footer ========== -->
              <div v-if="isCustomFooter">
                <slot name="customFooter" :index="item_i" :type="'이후사진'"></slot>
              </div>
              <div v-else class="mt-2">
                <p v-if="isPrint">{{ item.이후사진.input }}</p>
                <ml-input v-else v-model="item.이후사진.input" :placeholder="item.이후사진.placeholder" class="w-full flex-1"/>
              </div>
            </div>
          </td>
        </tr>
        </tbody>
      </table>
    </div>

    <!-- Mobile 카드 레이아웃 -->
    <div class="mobile-layout" v-if="dataList.length > 0 || isPrint">
      <!-- 모바일 전체 선택 헤더 (아이템이 있을 때만) -->
      <div
        class="mobile-header"
        v-if="!isPrint && dataList.length > 0 && isCheckMode && !readonly"
        @click="toggleAllCheck"
      >
        <vs-checkbox :value="checkData.length === dataList.length && 0 < dataList.length" />
        <span class="mobile-header-text">전체 선택</span>
      </div>

      <!-- 모바일 카드형 아이템들 -->
      <div class="mobile-cards-container">
        <div
          v-for="(item, item_i) in dataList"
          :key="`mobile_filelist_${item.id}_${item_i}`"
          class="mobile-card"
          :class="{ 'selected': checkData.includes(item.id), 'print-mode': isPrint }"
        >
          <!-- 카드 헤더 (체크박스 + 인덱스 + 삭제 버튼) -->
          <div class="mobile-card-header" v-if="!isPrint">
            <div class="mobile-card-header-left">
              <vs-checkbox
                v-if="isCheckMode && !readonly"
                v-model="checkData"
                :vs-value="item.id"
              ></vs-checkbox>
              <span class="card-index">{{ item_i + 1 }}번째 사진</span>
            </div>
            <vs-button
              v-if="isCheckMode && !readonly"
              class="mobile-delete-btn"
              color="danger"
              type="flat"
              size="small"
              @click="handleDeleteSingleItem(item_i)"
            >
              삭제
            </vs-button>
          </div>
          <div class="mobile-card-header print-header" v-else>
            <span class="card-index">{{ item_i + 1 }}번째 사진</span>
          </div>

          <!-- 카드 내용 -->
          <div class="mobile-card-content">
            <!-- 조치 전 사진 -->
            <div class="mobile-photo-section">
              <label class="mobile-field-label">조치 전 사진</label>
              <div class="mobile-photo-container">
                <div v-if="isPrint" class="mobile-print-photo">
                  <img :src="item.이전사진.path" class="mobile-print-img" alt="조치 전 사진"/>
                </div>
                <div v-else class="upload-content__file mobile-upload">
                  <div class="upload-content__content">
                    <FileUploaderTransparent
                      style="background-size: contain; background-repeat: no-repeat"
                      v-model="item.이전사진.image"
                      :readonly="readonly"
                      @input="setFile(item_i, '이전사진', item.이전사진.image)"
                      @progress="(state) => { fileProgress(item_i, '이전사진',  state) }"
                    />
                  </div>
                  <simple-spinner
                    v-if="item.이전사진.showSpinner"
                    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #cdcdcdaa"
                  />
                </div>

                <!-- 사진 설명 -->
                <div class="mobile-photo-input">
                  <div v-if="isCustomFooter">
                    <slot name="customFooter" :index="item_i" :type="'이전사진'"></slot>
                  </div>
                  <div v-else>
                    <p v-if="isPrint" class="mobile-print-input">{{ item.이전사진.input }}</p>
                    <ml-input
                      v-else
                      v-model="item.이전사진.input"
                      :placeholder="item.이전사진.placeholder || '조치 전 사진 설명을 입력하세요'"
                      class="w-full mobile-input"
                    />
                  </div>
                </div>
              </div>
            </div>

            <!-- 조치 후 사진 -->
            <div class="mobile-photo-section">
              <label class="mobile-field-label">조치 후 사진</label>
              <div class="mobile-photo-container">
                <div v-if="isPrint" class="mobile-print-photo">
                  <img :src="item.이후사진.path" class="mobile-print-img" alt="조치 후 사진"/>
                </div>
                <div v-else class="upload-content__file mobile-upload">
                  <div class="upload-content__content">
                    <FileUploaderTransparent
                      style="background-size: contain; background-repeat: no-repeat"
                      v-model="item.이후사진.image"
                      :readonly="readonly"
                      @input="setFile(item_i, '이후사진', item.이후사진.image)"
                      @progress="(state) => { fileProgress(item_i, '이후사진', state) }"
                    />
                  </div>
                  <simple-spinner
                    v-if="item.이후사진.showSpinner"
                    style="position: absolute; top: 0; left: 0; width: 100%; height: 100%; background-color: #cdcdcdaa"
                  />
                </div>

                <!-- 사진 설명 -->
                <div class="mobile-photo-input">
                  <div v-if="isCustomFooter">
                    <slot name="customFooter" :index="item_i" :type="'이후사진'"></slot>
                  </div>
                  <div v-else>
                    <p v-if="isPrint" class="mobile-print-input">{{ item.이후사진.input }}</p>
                    <ml-input
                      v-else
                      v-model="item.이후사진.input"
                      :placeholder="item.이후사진.placeholder || '조치 후 사진 설명을 입력하세요'"
                      class="w-full mobile-input"
                    />
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>

      <!-- 모바일 하단 항목 추가 버튼 (아이템이 있을 때만) -->
      <div class="mobile-add-button-container" v-if="!isPrint && dataList.length > 0">
        <vs-button
          class="mobile-add-btn"
          color="primary"
          type="filled"
          size="large"
          @click="handleAdd"
        >
          <i class="feather icon-plus mr-2"></i>
          사진 추가
        </vs-button>
      </div>
    </div>

    <!-- 삭제 확인 팝업 -->
    <vs-popup class="popup-example" title="삭제 확인" :active.sync="showDeleteConfirm">
      <div class="popup-content">
        <p class="delete-message">{{ deleteMessage }}</p>
        <div class="popup-buttons">
          <vs-button
            color="danger"
            type="filled"
            @click="confirmDelete"
          >
            삭제
          </vs-button>
          <vs-button
            color="dark"
            type="flat"
            @click="cancelDelete"
          >
            취소
          </vs-button>
        </div>
      </div>
    </vs-popup>
  </div>
</template>

<script>
import FileUploaderTransparent from "@/components/FileUploaderTransparent2";
import SimpleSpinner from "@/components/spinner/SimpleSpinner.vue";

export default {
  name: "PhotoUploadBeforeAfterTable",
  components: {SimpleSpinner, FileUploaderTransparent},
  props: {
    isPrint: Boolean,
    readonly: Boolean,
    id: String,
    value: Array, // [{ id : 0, 이전사진: {}, 이후사진: {} }]
    // 사진리스트 { id:0, fileName:'test1.txt', fileSize:1234, path:'', thumb:'', input:'' }
    isShowTitle: {
      type: Boolean,
      default: true,
    },
    sectionTitle: String,
    customTitle: {
      type: Boolean,
      default: false,
    },
    isCheckMode: {
      type: Boolean,
      default: true,
    },
    isCustomFooter: {
      type: Boolean,
      default: false,
    },
  },
  watch: {
    value: {
      handler(value) {
        this.dataList = value;
      },
    },
    dataList: {
      immediate: true,
      deep: true,
      handler(value) {
        this.$emit("input", value);
      },
    },
    isPrint: {
      immediate: true,
      deep: true,
      handler(value) {
        if (value) {
          this.$nextTick(() => {
            if (this.$refs.printPhotoUploadGridModulHead) this.printHeadHeight = (this.$refs.printPhotoUploadGridModulHead.clientHeight + 100) / 2;
            else this.printHeadHeight = 80;
          });
        }
      },
    },
  },
  data() {
    return {
      printHeadHeight: 80,
      dataList: [],
      checkData: [],
      showDeleteConfirm: false,
      deleteMessage: '',
      deleteAction: null,
      deleteIndex: null,
      deleteItemId: null,
    };
  },
  created() {
    this.fillEmptyFileList();
  },
  methods: {
    generateUniqueId() {
      return `_${Math.random().toString(36).substr(2, 9)}`;
    },
    fillEmptyFileList() {
      if (this.dataList.length === 0) {
        this.handleAdd()
      }
    },
    // All 체크박스 클릭
    onClickAllCheckbox() {
      if (this.checkData.length === this.dataList.length) this.checkData = [];
      else this.checkData = this.dataList.map((item) => item.id);
    },
    // 전체 선택 토글 (모바일 헤더 클릭 시)
    toggleAllCheck() {
      if (this.checkData.length === this.dataList.length) {
        this.checkData = [];
      } else {
        this.checkData = this.dataList.map((item) => item.id);
      }
    },
    handleAdd() {
      this.dataList.push(
        {
          id: this.generateUniqueId(),
          이전사진: {showSpinner: false },
          이후사진: {showSpinner: false }
        });
    },
    handleRemove() {
      const selectedCount = this.dataList.filter(item => this.checkData.includes(item.id)).length;
      if (selectedCount === 0) {
        this.$vs.notify({
          title: '알림',
          text: '삭제할 항목을 선택해주세요.',
          color: 'warning'
        });
        return;
      }

      this.deleteMessage = `선택된 ${selectedCount}개의 사진을 삭제하시겠습니까?`;
      this.deleteAction = 'batch';
      this.showDeleteConfirm = true;
    },
    // 개별 항목 삭제 확인
    handleDeleteSingleItem(index) {
      this.deleteMessage = `${index + 1}번째 사진을 삭제하시겠습니까?`;
      this.deleteAction = 'single';
      this.deleteIndex = index;
      this.deleteItemId = this.dataList[index].id; // 삭제할 항목의 ID 저장
      this.showDeleteConfirm = true;
    },
    // 삭제 확인
    confirmDelete() {
      if (this.deleteAction === 'batch') {
        this.executeBatchDelete();
      } else if (this.deleteAction === 'single') {
        this.executeSingleDelete();
      }
      this.showDeleteConfirm = false;
    },
    // 삭제 취소
    cancelDelete() {
      this.showDeleteConfirm = false;
      this.deleteAction = null;
      this.deleteIndex = null;
      this.deleteItemId = null;
      this.deleteMessage = '';
    },
    // 선택삭제 실행
    executeBatchDelete() {
      this.dataList = this.dataList.filter((item) => !this.checkData.includes(item.id));
      this.checkData = [];

      this.$vs.notify({
        title: '삭제 완료',
        text: '선택된 사진이 삭제되었습니다.',
        color: 'success'
      });
    },
    // 개별 항목 삭제 실행
    executeSingleDelete() {
      this.dataList.splice(this.deleteIndex, 1);
      // 삭제된 항목의 체크 상태도 제거
      this.checkData = this.checkData.filter(id => id !== this.deleteItemId);

      this.$vs.notify({
        title: '삭제 완료',
        text: '사진이 삭제되었습니다.',
        color: 'success'
      });
    },
    setFile(index, type, file) {
      this.dataList[index][type].id = file ? file.id : null;
      this.dataList[index][type].path = file ? file.path : null;
      this.dataList[index][type].fileName = file ? file.fileName : null;
    },
    fileProgress (index, type, state) {
      console.log("fileProgress", index, state)
      if (state === 'start') {
        this.dataList[index][type].showSpinner = true;
      } else if (state === 'success') {
        this.dataList[index][type].showSpinner = false;
        this.$toast.open({type: 'default', message: '이미지 업로드가 완료되었습니다.', position: 'bottom', duration: 2000});
      } else if (state === 'fail') {
        this.dataList[index][type].showSpinner = false;
        this.$toast.open({type: 'error', message: '이미지 업로드가 실패했습니다.', position: 'bottom', duration: 2000});
      }
    },
  }
}
</script>

<style scoped lang="scss">
$border: 1px solid #cdcdcd;
$bg: #f9f9f9;
$mobile-breakpoint: 768px;
$mobile-card-bg: #ffffff;
$mobile-card-border: 1px solid #e8e8e8;
$mobile-card-shadow: 0 2px 8px rgba(0, 0, 0, 0.1);
$mobile-selected-bg: #f0f9ff;
$mobile-selected-border: 1px solid #3b82f6;

/* 헤더 스타일 */
.header-buttons {
  display: flex;
  align-items: center;
}

.desktop-only {
  display: inline-flex;
}

/* 반응형 레이아웃 제어 */
.desktop-layout {
  display: block;
}
.mobile-layout {
  display: none;
}

/* 빈 목록 안내 메시지 */
.empty-list-message {
  padding: 60px 20px;
  text-align: center;
  background: #f8fafc;
  border: 2px dashed #cbd5e1;
  border-radius: 12px;
  margin-bottom: 20px;
}

.empty-content {
  max-width: 300px;
  margin: 0 auto;
}

.empty-icon {
  font-size: 48px;
  color: #94a3b8;
  margin-bottom: 16px;
}

.empty-text {
  font-size: 16px;
  color: #64748b;
  margin-bottom: 24px;
  font-weight: 500;
}

.empty-add-btn {
  min-height: 44px;
  padding: 12px 24px;
  font-weight: 600;

  .feather {
    font-size: 16px;
  }
}

@media (max-width: $mobile-breakpoint) {
  .desktop-layout {
    display: none;
  }
  .mobile-layout {
    display: block;
  }

  /* 모바일에서 항목추가 버튼 숨김 */
  .desktop-only {
    display: none !important;
  }

  /* 모바일 헤더 최적화 */
  .header-buttons {
    .vs-button {
      min-height: 40px;
      font-size: 14px;
      padding: 8px 16px;
    }
  }

  /* 빈 목록 메시지 모바일 최적화 */
  .empty-list-message {
    padding: 40px 16px;
    margin-bottom: 16px;
  }

  .empty-icon {
    font-size: 40px;
  }

  .empty-text {
    font-size: 15px;
  }
}

/* Desktop Table Styles */
table {
  width: 100%;
  table-layout: fixed;
  border-collapse: collapse;
  th,
  td {
    padding: 15px 8px;
    text-align: center;
    border: 1px solid #cdcdcd;
  }

  th {
    font-weight: 500;
    font-size: 14px;
    line-height: 18px;
    color: #3c3c3c;
    background: #f9f9f9;
  }

  td {
    font-weight: 400;
    font-size: 14px;
    line-height: 18px;
    color: #3c3c3c;
    box-sizing: content-box;
  }
}

.upload-content__file {
  width: 100%;
  padding-top: 56.25%;
  position: relative;
  border: 1px solid #cdcdcd;
  border-radius: 6px;

  .upload-content__content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-position: center center;
    background-size: cover;

    .printImg {
      background-color: white;
      border-radius: 6px;
    }
  }
}

/* Mobile Styles */
.mobile-header {
  display: flex;
  align-items: center;
  padding: 15px;
  background-color: $bg;
  border: $border;
  border-radius: 8px;
  margin-bottom: 15px;
  gap: 10px;
  cursor: pointer;
  transition: all 0.2s ease;
  user-select: none;

  &:hover {
    background-color: #f1f5f9;
    border-color: #94a3b8;
  }

  &:active {
    transform: scale(0.98);
  }

  .mobile-header-text {
    font-weight: 500;
    font-size: 16px;
    color: #374151;
    flex: 1;
  }

  .vs-checkbox {
    transform: scale(1.2);
    pointer-events: none;
  }
}

.mobile-cards-container {
  display: flex;
  flex-direction: column;
  gap: 15px;
}

.mobile-card {
  background: $mobile-card-bg;
  border: $mobile-card-border;
  border-radius: 12px;
  box-shadow: $mobile-card-shadow;
  overflow: hidden;
  transition: all 0.3s ease;

  &.selected {
    background: $mobile-selected-bg;
    border: $mobile-selected-border;
    transform: translateY(-2px);
    box-shadow: 0 4px 12px rgba(59, 130, 246, 0.15);
  }

  &.print-mode {
    box-shadow: none;
    border: $border;
    margin-bottom: 10px;
  }
}

.mobile-card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 15px 20px;
  background: linear-gradient(135deg, #f8fafc 0%, #f1f5f9 100%);
  border-bottom: 1px solid #e2e8f0;

  &.print-header {
    background: $bg;
    justify-content: center;
  }

  .mobile-card-header-left {
    display: flex;
    align-items: center;
    gap: 12px;
  }

  .card-index {
    font-weight: 600;
    font-size: 16px;
    color: #1e293b;
  }

  .vs-checkbox {
    transform: scale(1.2);
  }

  .mobile-delete-btn {
    min-height: 32px;
    padding: 8px 12px;
    font-size: 12px;
    font-weight: 500;
    border-radius: 6px;

    &:hover {
      transform: translateY(-1px);
      box-shadow: 0 2px 6px rgba(220, 38, 38, 0.3);
    }
  }
}

.mobile-card-content {
  padding: 20px;
}

.mobile-photo-section {
  margin-bottom: 25px;

  &:last-child {
    margin-bottom: 0;
  }
}

.mobile-field-label {
  display: block;
  font-weight: 600;
  font-size: 15px;
  color: #374151;
  margin-bottom: 12px;
  line-height: 1.4;
}

.mobile-photo-container {
  display: flex;
  flex-direction: column;
  gap: 12px;
}

.mobile-upload {
  width: 100%;
  padding-top: 56.25%; // 16:9 비율
  position: relative;
  border: 1px solid #d1d5db;
  border-radius: 8px;

  .upload-content__content {
    position: absolute;
    top: 0;
    left: 0;
    right: 0;
    bottom: 0;
    background-position: center center;
    background-size: cover;
  }
}

.mobile-print-photo {
  width: 100%;
  min-height: 200px;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  overflow: hidden;
  background: #f9fafb;
}

.mobile-print-img {
  max-width: 100%;
  max-height: 100%;
  object-fit: contain;
}

.mobile-photo-input {
  .mobile-input {
    min-height: 44px;
    font-size: 16px;

    input {
      padding: 12px 16px;
      border-radius: 8px;
      border: 1px solid #d1d5db;

      &:focus {
        border-color: #3b82f6;
        box-shadow: 0 0 0 3px rgba(59, 130, 246, 0.1);
      }
    }
  }
}

.mobile-print-input {
  display: block;
  padding: 12px 16px;
  background: #f9fafb;
  border: 1px solid #e5e7eb;
  border-radius: 8px;
  font-size: 14px;
  color: #374151;
  min-height: 20px;
  line-height: 1.5;
}

/* 모바일 하단 항목 추가 버튼 */
.mobile-add-button-container {
  margin-top: 20px;
  padding: 0 5px;
}

.mobile-add-btn {
  width: 100%;
  min-height: 50px;
  font-size: 16px;
  font-weight: 600;
  border-radius: 12px;
  display: flex;
  align-items: center;
  justify-content: center;
  gap: 8px;

  .feather {
    font-size: 18px;
  }

  &:hover {
    transform: translateY(-2px);
    box-shadow: 0 6px 20px rgba(59, 130, 246, 0.3);
  }
}

/* 삭제 확인 팝업 스타일 */
.popup-content {
  padding: 20px;
  text-align: center;
}

.delete-message {
  font-size: 16px;
  color: #374151;
  margin-bottom: 25px;
  line-height: 1.5;
}

.popup-buttons {
  display: flex;
  gap: 15px;
  justify-content: center;

  .vs-button {
    min-width: 100px;
    min-height: 40px;
    font-weight: 600;
  }
}

/* 인쇄 시 PC 레이아웃 강제 적용 */
@media print {
  .desktop-layout {
    display: block !important;
  }
  .mobile-layout {
    display: none !important;
  }

  /* 테이블 인쇄 최적화 */
  .desktop-table-header,
  .desktop-table-row {
    break-inside: avoid;
    page-break-inside: avoid;
  }
}

/* 작은 모바일 화면 최적화 */
@media (max-width: 480px) {
  .mobile-card-content {
    padding: 15px;
  }

  .mobile-header {
    padding: 12px;
  }

  .mobile-card-header {
    padding: 12px 15px;

    .mobile-card-header-left {
      .card-index {
        font-size: 14px;
      }
    }

    .mobile-delete-btn {
      min-height: 28px;
      padding: 6px 10px;
      font-size: 11px;
    }
  }

  .mobile-add-btn {
    min-height: 48px;
    font-size: 15px;

    .feather {
      font-size: 16px;
    }
  }

  .popup-buttons {
    flex-direction: column;
    gap: 10px;

    .vs-button {
      width: 100%;
    }
  }
}
</style>
